import React, { Component } from 'react';
import FormItem from '../../components/FormItem/index';
import Wangeditor from '../../components/Wangeditor/index';
import { Form, Input, Button, message } from 'antd';
import services from '../../services/api';

const { TextArea } = Input;
class SiteAdd extends Component {
  constructor() {
    super();
    this.state = {
      detail: {}
    };
    this.actionType = 'add';
    this.type = '';
    this.id = '';
    this.api = 'site';
  }

  componentDidMount() {
    if (this.props.actionType) {
      this.actionType = this.props.actionType;
    } else {
      if (this.props.location.pathname.indexOf('edit') !== -1) {
        this.actionType = 'update';
        this.id = this.props.match.params.id;
        this.getDetail();
      }
      this.type = this.props.match.params.type;
    }
  }

  /**获取详情 */
  getDetail = () => {
    services[this.api].queryOne({ id: this.id }).then(data => {
      console.log(data);
      if (data.code === 0) {
        this.setState({
          detail: data.data
        });
        this.props.form.setFieldsValue({
          site_name: data.data.site_name,
          seo_title: data.data.seo_title,
          des: data.data.des,
          keywords: data.data.keywords,
          domain: data.data.domain
        });
      } else {
        message.error(data.msg);
      }
    });
  };

  /** 获取到列表url  */
  getListUrl = () => {
    const addUrlReg = /.+(?=\/add)/;
    const editUrlReg = /.+(?=\/\d+\/edit)/;
    if (this.props.location.pathname.match(addUrlReg) !== null) {
      return this.props.location.pathname.match(addUrlReg)[0];
    }
    if (this.props.location.pathname.match(editUrlReg) !== null) {
      return this.props.location.pathname.match(editUrlReg)[0];
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      console.log(values);
      const params = {
        ...values
      };
      if (this.actionType === 'update') {
        params.id = this.id;
      }
      if (!err) {
        services[this.api][this.actionType](params).then(data => {
          if (data.code === 0) {
            message.success(data.msg);
            // this.props.history.push(this.getListUrl());
          } else {
            message.error(data.msg);
          }
        });
      }
    });
  };
  normFile = e => {
    console.log(e);
  };

  render() {
    const formItems1 = [
      {
        label: {
          label: '网站名',
          className: 'tantuer-form-item'
        },
        name: 'site_name',
        options: {
          initialValue: '',
          rules: [{ required: true, message: '请输入网站名' }]
        },
        component: <Input placeholder="网站名" className="large" />
      },
      {
        label: {
          label: '域名',
          className: 'tantuer-form-item'
        },
        name: 'domain',
        options: {
          initialValue: ''
        },
        component: <TextArea placeholder="域名" className="default" />
      },
      {
        label: {
          label: 'seo_title',
          className: 'tantuer-form-item'
        },
        name: 'seo_title',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="网站SEO Title" className="large" />
      },

      {
        label: {
          label: '描述',
          className: 'tantuer-form-item'
        },
        name: 'des',
        options: {
          initialValue: ''
        },
        component: <TextArea placeholder="描述" className="default" />
      },
      {
        label: {
          label: '关键词',
          className: 'tantuer-form-item'
        },
        name: 'keywords',
        options: {
          initialValue: ''
        },
        component: <TextArea placeholder="关键词" className="default" />
      }
    ];

    return (
      <div>
        <Form onSubmit={this.handleSubmit} className="login-form">
          <div className="tantuer-field-area">
            {formItems1.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>

          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            提交
          </Button>
        </Form>
      </div>
    );
  }
}

export default Form.create()(SiteAdd);
